import { Button, CircularProgress, LinearProgress, Stack, Typography } from "@mui/material";
import { Link, Navigate, useParams } from "react-router-dom";
import { useFetchSurveyQuery } from "./surveysApi";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { CheckCheck, Pencil } from "lucide-react";
import { useResponsive } from "@/hooks";
import Frame from "@/components/Frame";

const SurveyDetailsPage = () => {
    const { isMobile } = useResponsive();
    const { organizationId, surveyId } = useParams<{ organizationId: string; surveyId: string }>();
    const survey = useFetchSurveyQuery({
        organizationId: organizationId || skipToken,
        surveyId: surveyId || skipToken,
    });

    return (
        <Stack spacing={2}>
            {survey.isLoading ? (
                <Stack flex={1} alignItems="center" py={5}>
                    <CircularProgress/>
                </Stack>
            ) : !survey.data ? (
                <Navigate to="/not-found" replace={true} />
            ) : (
                <Stack spacing={2}>
                    <Stack spacing={2} direction={isMobile ? "column" : "row"} justifyContent="space-between">
                        <Typography variant="h2">{survey.data.title}</Typography>
                        <Stack spacing={2} direction="row">
                            <Button
                                startIcon={<CheckCheck />}
                                size="small"
                                variant="outlined"
                                component={Link}
                                to="submit"
                            >
                                Responder
                            </Button>
                            <Button
                                startIcon={<Pencil />}
                                size="small"
                                variant="outlined"
                                component={Link}
                                to="edit"
                            >
                                Editar
                            </Button>
                        </Stack>
                    </Stack>
                    {(survey.data?.questions ?? []).map((question) => (
                        <Frame key={question.id}>
                            <Stack spacing={2} flex={1}>
                                <Typography variant="h4">{question.title}</Typography>
                                <Stack spacing={1} flex={1}>
                                    {(question?.options ?? []).map((option, optionIndex) => (
                                        <Stack key={`option-${optionIndex}`} direction="row" justifyContent="space-between" alignItems="center" flex={1}>
                                            <Typography variant="body1">{option.title}</Typography>
                                            <LinearProgress variant="determinate" value={Math.floor(Math.random() * 100)} sx={{ width: 300}} />
                                        </Stack>
                                    ))}
                                </Stack>
                            </Stack>
                        </Frame>
                    ))}
                </Stack>
            )}
        </Stack>
    );
}

export default SurveyDetailsPage;
